/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ComponentBase from '../ComponentBase';
import LifeCyclePropertyType, { LifeCycle } from '../LifeCycle';
import { AnyFunc } from '../Types';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass()
export default class LifeCycleManager extends ComponentBase
{
    @property
    protected componentName: string = '';

    @property({ type: LifeCyclePropertyType })
    protected lifeCycle: LifeCycle = LifeCycle.update;
    protected lifeCycleString: string = '';

    @property([cc.Node])
    protected nodes: cc.Node[] = [];

    private components: cc.Component[] = [];

    /** @hidden */
    protected onLoad(): void
    {
        this.lifeCycleString = LifeCycle[this.lifeCycle];

        this.getComponentsFromNodes()
            .updateLifeCycles();

        this.enabled = false;
    }

    private getComponentsFromNodes(): this
    {
        this.nodes.forEach(node =>
            {
                const component: cc.Component = node.getComponent(this.componentName);
                if (!component) { return; }
                this.components.push(component);
            });
        return this;
    }

    private updateLifeCycles(): this
    {
        if (!this.components || this.components.length < 1) { return; }

        this.components.forEach((component, index, components) =>
            {
                const previousComponent: cc.Component = index < 1 ? null : components[index - 1];
                const nextComponent: cc.Component = components[index + 1];

                const updateFunc: AnyFunc = component[this.lifeCycleString].bind(component);

                // First comp, no change to signature.
                if (!previousComponent)
                {
                    if (!nextComponent) { return; }

                    component[this.lifeCycleString] = (...args: any[]) =>
                    {
                        updateFunc(...args);
                        nextComponent[this.lifeCycleString](component, ...args);
                    };
                    return;
                }

                // Update remaining comps with check object.
                component[this.lifeCycleString] = (check: object = null, ...args: any[]) =>
                {
                    if (check !== previousComponent) { return; }
                    updateFunc(...args);
                    if (nextComponent) { nextComponent[this.lifeCycleString](component, ...args); }
                };
                return;
            });
        return this;
    }
}
